import { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { isEmpty } from "lodash";
import { CircularProgress, Paper } from "@mui/material";
import {
  Close,
  LocationOnOutlined,
  ReportGmailerrorredOutlined
} from "@mui/icons-material";
import DoiTuongKiemKeMarker from "../onclick/clickDoiTuongKiemKe";
import { MyForm } from "../MapLibrary";
import { FormFilter } from "./FormFilter";
import L from "leaflet";
import { API_GEOSERVER_URI_QUERY } from "../../../api2";

export default function FormSearch({ setCenter, setZoom }) {
  const formikRef = useRef(null);
  const [dataFormik, setFormik] = useState({
    doiTuongTimKiem: null,
    tinhThanh: null,
    quanHuyen: null,
    phuongXa: null,
    search: ""
  });
  const validationSchema = Yup.object().shape({});
  const [valuePosition, setValuePosition] = useState(null);
  const [valueDataDiemTram, setValueDataDiemTram] = useState(null);
  const [dataSearchList, setDataSearchList] = useState(null);
  const [offShowDataSearchList, setOffShowDataSearchList] = useState(null);

  // const doiTuongKiemKeList = doiTuongKiemKeListConst

  const refFormSearch = useRef();
  const refDataSearch = useRef();
  useEffect(() => {
    if (refFormSearch?.current) {
      const disableClickPropagation = L?.DomEvent?.disableClickPropagation;
      const disableScroll = L?.DomEvent?.disableScrollPropagation;
      disableClickPropagation(refFormSearch.current);
      disableScroll(refFormSearch.current);
    }
    if (refDataSearch?.current) {
      const disableClickPropagation = L?.DomEvent?.disableClickPropagation;
      const disableScroll = L?.DomEvent?.disableScrollPropagation;
      disableClickPropagation(refDataSearch.current);
      disableScroll(refDataSearch.current);
    }
  }, []);

  const onSubmitSearch = values => {
    setOffShowDataSearchList("loading");
    setValuePosition(1);
    setValueDataDiemTram(null);
    const cqlFilter = `TenVungSanXuat ilike \'%25${values.search}%25\'
        ${
          values?.doiTuongTimKiem?.maMuc
            ? " and loai ilike '%25" + values?.doiTuongTimKiem?.maMuc + "%25'"
            : ""
        }
        ${
          values?.tinhThanh?.ma
            ? " and matinh ilike '%25" + values?.tinhThanh?.ma + "%25'"
            : ""
        }
        ${
          values?.quanHuyen?.ma
            ? " and mahuyen ilike '%25" + values?.quanHuyen?.ma + "%25'"
            : ""
        }
        ${
          values?.phuongXa?.ma
            ? " and maxa ilike '%25" + values?.phuongXa?.ma + "%25'"
            : ""
        }`;
    // Construct the GetFeatureInfo URL
    //kiem_ke_tnn is workspace, doituongkiemke is layer of geoserver
    const url =
      API_GEOSERVER_URI_QUERY +
      `?service=WFS&version=2.0.0&SRS=EPSG:4326&request=GetFeature&typeName=CaChinhBong:VungSanXuat&outputFormat=application/json&CQL_FILTER=${cqlFilter}`;
    // Send the GetFeatureInfo request
    fetch(url)
      .then(responsive => responsive.text())
      .then(data => {
        const dataJson = JSON.parse(data);
        setDataSearchList(dataJson?.features);
        setOffShowDataSearchList(false);
      })
      .catch(error => {})
      .finally(() => {
        setOffShowDataSearchList(false);
      });
  };
  const onclickRowDataSearch = dataSearch => {
    const location = [
      dataSearch?.geometry?.coordinates?.[1],
      dataSearch?.geometry?.coordinates?.[0]
    ];
    setZoom(15);
    setCenter(location);
    setValuePosition(location);
    setValueDataDiemTram(dataSearch?.properties);
    setOffShowDataSearchList(true);
  };

  let showDataSearchList = null;
  if (dataSearchList) {
    if (isEmpty(dataSearchList)) {
      showDataSearchList = (
        <>
          <Paper
            sx={{
              position: "absolute",
              zIndex: 1000,
              width: "calc(48vw - 16px)",
              height: "38px",
              marginLeft: "60px",
              marginTop: "87px",
              textAlign: "left",
              overflowY: "auto",
              maxHeight: "300px",
              borderRadius: "5px",
              backgroundColor: "#ffff",
              boxShadow: 0
            }}
          >
            <div
              style={{ display: "flex", height: "100%", alignItems: "center" }}
            >
              <ReportGmailerrorredOutlined style={{ margin: "0 3 0 10" }} />
              Dữ liệu tìm kiếm không khả dụng...
            </div>
          </Paper>
          <Paper
            sx={{
              position: "absolute",
              zIndex: 1000,
              width: "23px",
              marginLeft: "calc(48vw + 9px)",
              marginTop: "89px",
              backgroundColor: "rgba(0,0,0,0)",
              boxShadow: 0
            }}
          >
            <div
              className="banDo-searchList-itemClose"
              onClick={() => setOffShowDataSearchList(true)}
            >
              <Close />
            </div>
          </Paper>
        </>
      );
    } else {
      showDataSearchList = (
        <>
          <Paper
            sx={{
              position: "absolute",
              zIndex: 3000,
              width: "calc(48vw - 16px)",
              marginLeft: "60px",
              marginTop: "87px",
              textAlign: "left",
              overflowY: "auto",
              maxHeight: "300px",
              borderRadius: "6px",
              backgroundColor: "#ffff",
              boxShadow: 0
            }}
          >
            <div>
              {dataSearchList?.map((dataSearch, index) => {
                // const valueLoaiDoiTuong = doiTuongKiemKeList?.find(x => x.maMuc === dataSearch?.properties?.loai) || null
                return (
                  <tr
                    className="capPhep-banDo-searchList-contaier"
                    style={{
                      display: "flex",
                      marginBottom: "1px",
                      paddingTop: "1px",
                      cursor: "pointer"
                    }}
                    onClick={() => onclickRowDataSearch(dataSearch)}
                  >
                    <td
                      style={{
                        width: "25px",
                        display: "flex",
                        alignItems: "center"
                      }}
                    >
                      <LocationOnOutlined
                        style={{
                          width: "25px",
                          height: "22px",
                          color: "#656262"
                        }}
                      />
                    </td>
                    <td style={{ display: "flex", alignItems: "center" }}>
                      <span
                        style={{
                          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                          fontSize: "14px"
                        }}
                      >
                        {dataSearch?.properties?.TenVungSanXuat}
                        {/* {valueLoaiDoiTuong?.tenMuc ? (
                                                    <>
                                                        &nbsp;&#40;{valueLoaiDoiTuong.tenMuc}&#41;
                                                    </>
                                                ) : null} */}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </div>
          </Paper>
          <Paper
            sx={{
              position: "absolute",
              zIndex: 1000,
              width: "23px",
              marginLeft: "calc(48vw + 9px)",
              marginTop: "89px",
              backgroundColor: "rgba(0,0,0,0)",
              boxShadow: 0
            }}
          >
            <div
              className="banDo-searchList-itemClose"
              onClick={() => setOffShowDataSearchList(true)}
            >
              <Close />
            </div>
          </Paper>
        </>
      );
    }
  }

  if (offShowDataSearchList && offShowDataSearchList !== "loading") {
    showDataSearchList = null;
  } else if (offShowDataSearchList === "loading") {
    showDataSearchList = (
      <Paper
        sx={{
          position: "absolute",
          zIndex: 1000,
          width: "calc(48vw - 16px)",
          height: "38px",
          marginLeft: "60px",
          marginTop: "87px",
          textAlign: "left",
          overflowY: "auto",
          maxHeight: "300px",
          borderRadius: "5px",
          backgroundColor: "#ffff",
          boxShadow: 0
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <CircularProgress style={{ width: 25, height: 25 }} />
        </div>
      </Paper>
    );
  }

  return (
    <>
      {/* <DoiTuongKiemKeMarker valuePosition={valuePosition} valueData={valueDataDiemTram} setOffShowDataSearchList={setOffShowDataSearchList} doiTuongKiemKeList={doiTuongKiemKeList} /> */}
      <DoiTuongKiemKeMarker
        valuePosition={valuePosition}
        valueData={valueDataDiemTram}
        setOffShowDataSearchList={setOffShowDataSearchList}
      />
      <Paper
        ref={refFormSearch}
        sx={{
          width: "48vw",
          position: "absolute",
          zIndex: 2000,
          marginTop: 0,
          marginLeft: "54px",
          textAlign: "left",
          backgroundColor: "rgba(0,0,0,0)",
          boxShadow: 0
        }}
      >
        <div style={{ padding: "7px 10px 0px 6px" }}>
          <MyForm
            formikRef={formikRef}
            showSearch={false}
            dataFormik={dataFormik}
            onSubmitAPI={() => {}}
            validationSchema={validationSchema}
            editable={true}
            showFormikState={false}
            children={propsForm => (
              <FormFilter
                propsForm={propsForm}
                onSubmitSearch={onSubmitSearch}
              />
            )}
          />
        </div>
      </Paper>
      <div ref={refDataSearch}>{showDataSearchList}</div>
    </>
  );
}
